import { createPaginationHelper, createPredicate } from "./config-utils.js";
const paginationConfigs = [
    {
        name: 'modernRelay',
        type: 'cursor',
        cursorArg: 'after',
        cursorPath: 'pageInfo.endCursor',
        pageSizeArg: 'first',
        hasMorePath: 'pageInfo.hasNextPage',
        itemsPath: 'nodes'
    },
    {
        name: 'relay',
        type: 'cursor',
        cursorArg: 'after',
        cursorPath: 'edges[(@.length-1)].cursor',
        pageSizeArg: 'first',
        hasMorePath: 'pageInfo.hasNextPage',
        itemsPath: 'edges[*].node'
    },
    {
        name: 'stripe',
        type: 'cursor',
        cursorArg: 'starting_after',
        cursorPath: 'data[(@.length-1)].id',
        pageSizeArg: 'limit',
        hasMorePath: 'has_more',
        itemsPath: 'data'
    },
    {
        name: 'elasticpath',
        type: 'offset',
        offsetArg: 'page.offset',
        itemsPath: 'data',
        itemTotalPath: 'meta.results.total'
    },
    {
        name: 'offset1',
        type: 'offset',
        offsetArg: 'from',
        itemTotalPath: 'total',
        itemsPath: 'items'
    },
    {
        name: 'bigcommerce',
        type: 'page',
        pageArg: 'page',
        pageSizeArg: 'limit',
        pageTotalPath: 'meta.pagination.total_pages',
        itemsPath: 'data'
    },
    {
        name: 'page1',
        type: 'page',
        pageArg: 'page',
        pageTotalPath: 'info.pages',
        itemsPath: 'results'
    },
    {
        name: 'sanity',
        type: 'offset',
        offsetArg: 'offset',
        pageSizeArg: 'limit',
        itemTotalPath: '',
        itemsPath: '$'
    }
];
export const paginationSchemes = paginationConfigs.map(({ name, ...config }) => ({
    ...config,
    name,
    predicate: createPredicate(config),
    createPaginationHelper: (options) => createPaginationHelper(config, options)
}));
